module.exports = "/assets/data/6180a187f3a657a971d683ac62380ee6-G41.data.json";